import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import AuthenticationVEdit from '../edit/index';
import AuthenticationVPass from '../pass/index';
import AuthenticationVReject from '../reject/index';
export default {
  name: 'AuthenticationVList',
  components: {
    AuthenticationVEdit: AuthenticationVEdit,
    AuthenticationVPass: AuthenticationVPass,
    AuthenticationVReject: AuthenticationVReject
  },
  data: function data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      authenticationVStatsEnums: [],
      authenticationVPayStatsEnums: [],
      isSelect: this.checkauthority('v_auth_select'),
      isCreate: this.checkauthority('v_auth_create'),
      isUpdate: this.checkauthority('v_auth_update'),
      isDelete: this.checkauthority('v_auth_delete'),
      isPass: this.checkauthority('v_auth_pass'),
      isReject: this.checkauthority('v_auth_reject'),
      selectForm: {
        memberNo: null,
        stats: 0,
        payStats: null,
        createTimes: []
      },
      editDisabled: false,
      dialogVisible: false,
      passDialogVisible: false,
      rejectDialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false
    };
  },
  methods: {
    getImageImages: function getImageImages(row) {
      var images = [];
      var urls = JSON.parse(row.images);
      for (var index in urls) {
        var url = urls[index];
        images.push(this.downloadUrl + url.url);
      }
      return images;
    },
    getImagesImage: function getImagesImage(row) {
      var url = JSON.parse(row.images)[0].url;
      return this.downloadUrl + url;
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this2 = this;
      var msg = '删除';
      if (data.isDel === 1) {
        msg = '恢复';
      }
      this.$confirm('此操作将永久' + msg + '该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (data.isDel === 0) {
          _this2.daleteApi(index, data);
        } else {
          _this2.updateApi(index, data);
        }
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                vauthId: data.vauthId
              };
              _context2.n = 1;
              return api.DELETE_AUTHENTICATIONV(par);
            case 1:
              _this3.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateApi: function updateApi(index, data) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                vauthId: data.vauthId,
                isDel: 0
              };
              _context3.n = 1;
              return api.UPDATE_AUTHENTICATIONV(par);
            case 1:
              _this4.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.DELETE_BATCH_AUTHENTICATIONV(par);
            case 1:
              _this5.$message.success('操作成功');
              _this5.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this6 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this6.tableSelects.forEach(function (element) {
          par.push(element.vAuthId);
        });
        _this6.deleteBatchApi(par);
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑认证标签');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    passEditOpen: function passEditOpen(index, data) {
      this.$refs.pass.setTitle('开通认证');
      this.passDialogVisible = true;
      this.$refs.pass.setData(data);
    },
    rejectEditOpen: function rejectEditOpen(index, data) {
      this.$refs.reject.setTitle('驳回');
      this.rejectDialogVisible = true;
      this.$refs.reject.setData(data);
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    passEditClose: function passEditClose() {
      this.passDialogVisible = false;
    },
    rejectEditClose: function rejectEditClose() {
      this.rejectDialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.memberNo = null;
      this.selectForm.stats = 0;
      this.selectForm.payStats = null;
      this.selectForm.createTimes = [];
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                pageNo: _this7.pageNo,
                pageSize: _this7.pageSize,
                memberId: _this7.selectForm.memberNo,
                payStats: _this7.selectForm.payStats
              };
              if (_this7.selectForm.stats !== null && _this7.selectForm.stats === 3) {
                par.isDel = 1;
              } else {
                par.isDel = 0;
              }
              if (_this7.selectForm.stats !== null && _this7.selectForm.stats !== 3) {
                par.stats = _this7.selectForm.stats;
              }
              if (_this7.selectForm.createTimes.length > 0) {
                par.startCreateTime = _this7.selectForm.createTimes[0];
                par.endCreateTime = _this7.selectForm.createTimes[1];
              }
              _context5.n = 1;
              return api.GET_AUTHENTICATIONV_PAGE_LIST(par);
            case 1:
              res = _context5.v;
              _this7.tableData = res.body.datas;
              _this7.pageTotal = res.body.sumDataCount;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initTableData();
  }
};